import { errorForm, navigation } from '@origin-digital/reporting-client';
import {
  errorCodeToAnalyticsErrorCode,
  errorCodeToAnalyticsErrorMessage,
} from '../../../../services/analytics';
import { getHashOrQueryParam } from '../../../../window/WindowUtils';
import { FLOW_PARAM } from '../../../../constants/UrlParams';
import { ErrorFlow } from './ErrorFlow';

// maps flow to friendly uri for analytics
const errorFlowToAnalyticsPageName = {
  [ErrorFlow.login]: 'login',
  [ErrorFlow.register]: 'auth:register',
  [ErrorFlow.registerResetPassword]: 'auth:register-password',
  [ErrorFlow.resetPassword]: 'forgot-password',
  [ErrorFlow.callCentreResetPassword]: 'auth:registration-manual',
  [ErrorFlow.forgotEmail]: 'auth:forgot-email',
  [ErrorFlow.manualReg]: 'auth:manual-reg',
};

const errorFlowToAnalyticsTaskName = {
  [ErrorFlow.login]: 'login',
  [ErrorFlow.register]: 'my-account-registration',
  [ErrorFlow.registerResetPassword]: 'my-account-registration',
  [ErrorFlow.resetPassword]: 'forgot-password-new',
  [ErrorFlow.callCentreResetPassword]: 'auth:registration-manual',
  [ErrorFlow.forgotEmail]: 'forgot-email',
  [ErrorFlow.manualReg]: 'auth:manual-reg',
};

const fireErrorAnalytics = (errorCode: string) => {
  const errorFlow = getHashOrQueryParam(FLOW_PARAM) as ErrorFlow;
  navigation('screen', {
    currentUri: '',
    friendlyUri: `originenergy:my-account:${errorFlowToAnalyticsPageName[errorFlow] ||
      'login'}:error`,
  });
  if (errorCode) {
    errorForm({
      errorCode: errorCodeToAnalyticsErrorCode(errorCode),
      errorMessage: errorCodeToAnalyticsErrorMessage(errorCode),
      formName: errorFlowToAnalyticsTaskName[errorFlow] || 'login',
    });
  }
};

export { fireErrorAnalytics };
